import { createFileRoute } from "@tanstack/react-router";
import { SetPasswordForm } from "@/components/auth/set-password-form";

interface SetPasswordSearchParams {
	token: string;
	tenant: string;
}

export const Route = createFileRoute("/ustaw-haslo")({
	validateSearch: (search: Record<string, unknown>): SetPasswordSearchParams => ({
		token: (search.token as string) || "",
		tenant: (search.tenant as string) || "",
	}),
	component: SetPasswordPage,
});

function SetPasswordPage() {
	const { token, tenant } = Route.useSearch();
	return (
		<SetPasswordForm
			token={token}
			tenant={tenant}
			title="Witaj w Farmaster!"
			subtitle="Ustaw swoje haslo, aby aktywowac konto."
			submitLabel="Aktywuj konto"
			loadingLabel="Aktywowanie..."
			successTitle="Konto aktywowane"
			successMessage="Twoje konto zostalo aktywowane. Mozesz sie teraz zalogowac."
			errorFallback="Nie udalo sie aktywowac konta"
			invalidLinkMessage="Nieprawidlowy lub brakujacy link aktywacyjny."
		/>
	);
}
